import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export const useEventNameParam = () => {
	const eventName = useParams<{ eventName?: string }>().eventName;
	return useMemo(() => eventName, [eventName]);
};